import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
export function Guarantee() {
  return <section className="bg-mint-50 px-4 py-14 sm:py-20" data-id="element-191" data-mp="20m4phsgugev0">
      <div className="mx-auto max-w-2xl text-center" data-id="element-192" data-mp="24monszd5loiq">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full bg-mint-600 text-white ring-8 ring-mint-100" data-id="element-193" data-mp="24lwzm9lvyt2h">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-194" data-mp="2edj9o2mhmm3n" />
          <span className="mt-1 font-display text-lg font-extrabold leading-none" data-id="element-195" data-mp="2efdvrk9hwk9b">7 DAYS</span>
        </div>
        <h2 className="mt-6 font-display text-[28px] font-extrabold leading-tight text-plum-950 sm:text-4xl" data-id="element-196" data-mp="2ob7ifwgxhu4t">
          Your Purchase Is Protected by a 7-Day Guarantee
        </h2>
        <p className="mt-2 font-display text-lg font-extrabold text-mint-700" data-id="element-197" data-mp="2saoniosg0p9g">Explore the Complete Blueprint With Confidence</p>
        <div className="mt-5 space-y-3 text-base leading-relaxed text-slate-700" data-id="element-198" data-mp="xyi08rm9yi0s">
          <p data-id="element-199" data-mp="y0kyu01htjh4">
            Your purchase includes a 7-day money-back guarantee. You can access the digital resources, review the six-volume
            pathway, and explore the included documentation and planning tools.
          </p>
          <p data-id="element-200" data-mp="3iuu0g4hb9ioo">
            If the collection doesn’t meet your expectations, you can request a refund within seven days of purchase under
            the guarantee.
          </p>
        </div>
        <p className="mt-6 font-display text-2xl font-extrabold text-plum-900" data-id="element-201" data-mp="ffg87c8suz4d">Your Investment: Just $27</p>
        <div className="mt-6" data-id="element-202" data-mp="afk297gjkxm6">
          <CtaButton label="Get Instant Access to My Blueprint — $27" sub="Zero risk · 7-day guarantee" data-id="element-203" data-mp="agcz9gpp88r4" />
        </div>
      </div>
    </section>;
}